import { assertNever } from "./assertNever";
import { scenePath, type ManuscriptItem, type ZwChapter } from "./zwConfig";

export type TimelineFilters = { entries: string[] };
export const emptyTimelineFilters: TimelineFilters = {
  entries: [],
};

export function matchesTimelineFilters(
  entries: readonly string[],
  filters: TimelineFilters,
): boolean {
  if (filters.entries.length === 0) return true;
  return filters.entries.every((entry) => entries.includes(entry));
}

/** A view projection only: never use filtered positions for manuscript moves. */
export function filterTimelineManuscript(
  manuscript: ManuscriptItem[],
  sceneEntries: ReadonlyMap<string, readonly string[]>,
  filters: TimelineFilters,
): ManuscriptItem[] {
  if (filters.entries.length === 0) return manuscript;
  const filterChapter = (chapter: ZwChapter): ZwChapter[] => {
    const scenes = chapter.scenes.filter((scene) =>
      matchesTimelineFilters(
        sceneEntries.get(scenePath(chapter.folder, scene.file)) ?? [],
        filters,
      ),
    );
    return scenes.length > 0 ? [{ ...chapter, scenes }] : [];
  };
  return manuscript.flatMap((item): ManuscriptItem[] => {
    switch (item.type) {
      case "chapter":
        return filterChapter(item).map((chapter) => ({
          ...chapter,
          type: "chapter" as const,
        }));
      case "act": {
        const chapters = item.chapters.flatMap(filterChapter);
        return chapters.length > 0 ? [{ ...item, chapters }] : [];
      }
      case "map":
        return [];
      default:
        return assertNever(item);
    }
  });
}
